import type { CryptoSwapsTranslations } from "../interfaces/cryptoSwaps";

export const cryptoSwapsTranslations: CryptoSwapsTranslations = {
  // Page chrome
  page_title: "Comprar USDT",
  page_description: "Compra USDT con tu saldo en COP y recíbelos en tu wallet.",
  page_breadcrumb_wallets: "Billeteras",
  page_history_link: "Ver historial",
  page_new_order: "Nueva compra",

  // Organization (staff)
  org_picker_label: "Organización",
  org_picker_placeholder: "Busca por nombre, correo o ID",
  org_picker_loading: "Cargando organizaciones…",
  org_picker_empty: "Ninguna organización coincide",
  org_picker_searching: "Buscando…",
  org_picker_search_error: "No pudimos buscar organizaciones. Inténtalo de nuevo.",
  org_picker_catalog_error: "No pudimos cargar las organizaciones.",
  org_picker_catalog_truncated: "Se muestran las primeras organizaciones. Escribe para buscar el resto.",
  org_picker_required_hint: "Elige la organización cuya billetera se debita.",
  org_picker_org_hint: "La compra se debita de la billetera de esta organización.",
  org_picker_global_option: "Todas las organizaciones",
  org_picker_global_hint: "Mostrando compras de todas las organizaciones.",
  org_picker_filter_hint: "Mostrando solo las compras de esta organización.",

  // Availability
  pairs_load_failed: "No pudimos cargar la compra de USDT",
  pairs_retry: "Reintentar",
  pairs_empty:
    "La compra de USDT no está habilitada para tu cuenta. Habla con tu gerente de cuenta para activarla.",
  pair_label: "Moneda a comprar",
  pair_unavailable_title: "Compra no disponible en este momento",
  pair_unavailable_not_configured: "La compra de {{asset}} aún no está habilitada para tu organización.",
  pair_unavailable_disabled: "La compra de {{asset}} está pausada temporalmente. Inténtalo más tarde.",
  pair_unavailable_generic: "La compra de {{asset}} no está disponible ahora mismo.",
  pair_unavailable_breb_key:
    "Para comprar {{asset}} tu organización necesita una llave Bre-B activa: si una compra no se completa, los pesos se reembolsan a ella.",
  pair_breb_key_create: "Crear llave Bre-B",

  // Amounts
  amount_section_title: "¿Cuánto quieres comprar?",
  amount_send_label: "Pagas",
  amount_receive_label: "Recibes",
  amount_send_source: "De tu saldo en Coloca",
  amount_pricing: "Calculando el precio…",
  amount_invalid: "Escribe un monto mayor que cero.",
  amount_precision: "Usa como máximo {{decimals}} decimales.",
  amount_debit_note: "Se debitan {{amount}} {{currency}} por el redondeo del precio.",
  price_line: "1 {{asset}} = {{price}} {{currency}}",
  amount_below_min: "El mínimo por compra es {{amount}} {{currency}}.",
  amount_above_max: "El máximo por compra es {{amount}} {{currency}}.",
  amount_out_of_range: "Este monto está fuera de los límites por compra ({{min}} – {{max}} {{currency}}).",
  send_limits_hint: "Mín. {{min}} {{currency}} · Máx. {{max}} {{currency}} por compra",
  send_min_hint: "Mín. {{min}} {{currency}} por compra",
  send_max_hint: "Máx. {{max}} {{currency}} por compra",
  receive_limits_hint: "Si indicas cuánto recibir: mín. {{min}} · máx. {{max}} {{currency}}",
  receive_min_hint: "Si indicas cuánto recibir: mín. {{min}} {{currency}}",
  receive_max_hint: "Si indicas cuánto recibir: máx. {{max}} {{currency}}",
  receive_below_min: "Para indicar cuánto recibir, el mínimo es {{amount}} {{currency}}.",
  receive_above_max: "Para indicar cuánto recibir, el máximo es {{amount}} {{currency}}.",
  receive_out_of_range:
    "Para indicar cuánto recibir, el monto debe estar entre {{min}} y {{max}} {{currency}}.",
  balance_available: "Disponible: {{amount}} {{currency}}",
  balance_loading: "Consultando saldo…",
  balance_error: "No pudimos consultar el saldo.",
  balance_missing: "Esta organización no tiene saldo en {{currency}}.",
  balance_insufficient: "Saldo insuficiente · Disponible: {{amount}} {{currency}}",
  balance_pick_org: "Elige una organización para ver su saldo.",

  // Destination
  destination_title: "¿A qué wallet enviamos tus {{asset}}?",
  destination_network_label: "Red",
  destination_network_only: "Única red disponible",
  destination_address_label: "Dirección de la wallet",
  destination_address_placeholder: "0x…",
  destination_address_empty_hint: "Pega la dirección de la wallet que recibe.",
  destination_address_valid: "Dirección válida para {{network}}.",
  destination_address_invalid:
    "No es una dirección válida de {{network}}. Revisa que esté completa y sin errores.",
  destination_network_unsupported: "No podemos verificar direcciones en esta red.",
  destination_onchain_warning:
    "Asegúrate de que la wallet acepta {{asset}} en {{network}}. Si la red no coincide, los fondos se pierden.",
  destination_compare: "Compara los primeros y los últimos 6 caracteres con los de tu wallet.",
  concept_label: "Concepto (opcional)",
  concept_placeholder: "Ej. Recarga de tesorería",
  concept_too_long: "Usa como máximo {{max}} caracteres.",

  // Summary ticket
  quote_ticket_title: "Resumen",
  quote_valid_for: "Precio válido por {{time}}",
  quote_expired_badge: "Precio vencido",
  quote_pricing_badge: "Calculando…",
  quote_no_price_badge: "Sin precio",
  quote_timer_label: "Tiempo restante del precio",
  quote_announce_seconds: "Quedan {{seconds}} segundos de precio.",
  quote_announce_expired: "El precio venció.",
  quote_expired_title: "El precio venció",
  quote_expired_message: "Pide un precio nuevo para continuar. No se movió dinero.",
  quote_expired_action: "Obtener precio nuevo",
  quote_retry_action: "Volver a intentar",
  quote_manual_title:
    "No pudimos cotizar varias veces seguidas. Revisa el monto y pide el precio cuando estés listo.",
  quote_manual_action: "Obtener precio",
  quote_summary_price: "Precio",
  quote_summary_pay: "Pagas",
  quote_summary_receive: "Recibes",
  quote_summary_fees: "Comisiones",
  quote_summary_network: "Red",
  fees_included: "Incluidas en el precio",
  quote_submit: "Revisar compra",
  quote_submit_footnote:
    "Se debita de tu saldo en Coloca al confirmar. Si el envío falla, te devolvemos todo lo debitado.",

  // Review blocks
  block_readonly: "Tu rol puede ver esta sección, pero no comprar.",
  block_organization: "Elige la organización antes de cotizar.",
  block_unavailable: "La compra no está disponible ahora mismo.",
  block_empty: "Escribe cuánto quieres pagar o recibir.",
  block_amount: "Corrige el monto para ver el precio.",
  block_pricing: "Calculando el precio…",
  block_unpriced: "Sin precio todavía. Pídelo de nuevo para continuar.",
  block_expired: "El precio venció. Pide uno nuevo.",
  block_balance: "Tu saldo en Coloca no alcanza para esta compra.",
  block_destination: "Escribe una dirección de destino válida.",

  // Confirm dialog
  confirm_title: "Confirma tu compra",
  confirm_headline: "Vas a comprar {{receive}} por {{send}}",
  confirm_price: "Precio",
  confirm_fees: "Comisiones",
  confirm_network: "Red",
  confirm_concept: "Concepto",
  confirm_destination_title: "Wallet de destino",
  confirm_checksum_ok: "Formato válido",
  confirm_acknowledge:
    "Revisé la dirección y confirmo que es una wallet de {{network}}. Entiendo que el envío no se puede revertir.",
  confirm_expired_title: "El precio venció",
  confirm_expired_message: "Actualízalo para comprar al precio vigente. No se movió dinero.",
  confirm_refresh: "Actualizar precio",
  confirm_back: "Volver",
  confirm_create: "Comprar {{asset}}",
  confirm_network_warning_title: "Solo {{network}}",
  confirm_network_warning:
    "Verifica muy bien que la wallet de destino sea de {{network}}. Si la dirección pertenece a otra red (Ethereum, Tron, Solana, Polygon…), los fondos se pierden y no se pueden recuperar.",
  confirm_saved_wallet: "Wallet guardada: {{alias}}",
  confirm_will_save_wallet: "Se guardará como “{{alias}}” para próximas compras.",
  saved_wallets_label: "Wallet de destino",
  saved_wallets_new: "Nueva dirección",
  saved_wallets_manage: "Gestionar guardadas",
  saved_wallets_title: "Wallets guardadas",
  saved_wallets_description: "Direcciones de destino guardadas por tu organización para próximas compras.",
  saved_wallets_empty: "No hay wallets guardadas.",
  saved_wallets_delete: "Eliminar",
  saved_wallets_delete_confirm: "¿Eliminar esta wallet guardada?",
  saved_wallets_delete_failed: "No pudimos eliminar la wallet. Inténtalo de nuevo.",
  saved_wallet_save_label: "Guardar esta wallet para próximas compras",
  saved_wallet_save_hint: "Te pediremos tu código de autenticación (2FA) al confirmar.",
  saved_wallet_alias_label: "Nombre (opcional)",
  saved_wallet_alias_placeholder: "Ej. Tesorería Binance",
  saved_wallet_alias_too_long: "Usa como máximo {{max}} caracteres en el nombre.",
  saved_wallet_ownership_label: "¿De quién es esta wallet?",
  saved_wallet_ownership_own: "Es de mi organización",
  saved_wallet_ownership_third_party: "Es de un tercero",
  saved_wallet_holder_label: "Titular de la wallet",
  saved_wallet_holder_placeholder: "Nombre o razón social",
  saved_wallet_holder_required: "Indica el titular de la wallet.",
  saved_wallet_declaration:
    "Al guardarla declaras quién controla esta wallet. La declaración queda registrada con tu usuario.",
  saved_wallet_owner_own: "De tu organización",
  saved_wallet_owner_third_party: "De un tercero: {{holder}}",
  saved_wallet_two_factor_title: "Confirma la wallet a guardar",
  saved_wallet_two_factor_description:
    "Ingresa el código de tu app de autenticación para guardar la wallet y continuar con la compra.",
  saved_wallet_two_factor_required:
    "Para guardar wallets de destino necesitas activar la autenticación en dos pasos (2FA).",
  order_creating_title: "Creando tu compra…",
  order_creating_hint: "No cierres esta ventana.",
  transit_wallet: "Billetera {{currency}}",
  transit_your_wallet: "Tu wallet",
  transit_breb_key: "Tu llave Bre-B",
  transit_buy_aria:
    "Tus {{send}} salen de tu billetera, Coloca los convierte en {{receive}} y viajan por {{network}} a tu wallet.",
  transit_sell_aria:
    "Tus {{send}} llegan por {{network}}, Coloca los convierte en {{receive}} y los paga a tu llave Bre-B.",

  // Errors
  error_unconfirmed:
    "No pudimos confirmar si la compra se creó. Revisa el historial antes de intentarlo de nuevo, para no comprar dos veces.",
  error_unconfirmed_history: "Revisar historial",
  error_network: "No hay conexión. Revisa tu red e inténtalo de nuevo.",
  error_service_unavailable: "El servicio no está disponible en este momento. Inténtalo en unos minutos.",
  error_price_unavailable: "No pudimos obtener un precio ahora. Inténtalo de nuevo en unos segundos.",
  error_verification_required: "Tu organización debe completar su verificación antes de comprar.",
  error_forbidden: "No tienes permiso para esta operación.",
  error_breb_key_required:
    "Para comprar cripto tu organización necesita una llave Bre-B activa: los reembolsos se envían a ella.",
  error_otc_not_enabled: "Cripto no está activo para tu organización. Contacta a soporte para activarlo.",
  error_conflict: "Esta cotización ya se usó o la compra se está procesando. Revisa el historial.",
  error_not_found: "No encontramos lo que buscas.",
  error_quote_expired: "El precio venció antes de confirmar. Te mostramos uno nuevo.",
  error_rejected: "No pudimos procesar la solicitud. Revisa los datos e inténtalo de nuevo.",
  error_unknown: "Algo salió mal. Inténtalo de nuevo.",

  // Statuses
  status_created: "Creada",
  status_processing: "En proceso",
  status_paid: "Entregada",
  status_failed: "Fallida",
  status_cancelled: "Cancelada",
  status_reversed: "Revertida",
  filter_all: "Todas",

  // History
  history_title: "Historial de compras",
  history_description: "Tus compras de USDT, con su estado de entrega y el hash de cada transacción.",
  history_export: "Exportar CSV",
  history_export_empty: "No hay compras para exportar con estos filtros.",
  history_load_error: "No pudimos cargar el historial.",
  history_refresh: "Actualizar",
  history_count_one: "{{count}} compra",
  history_count_other: "{{count}} compras",
  history_filter_group: "Filtrar por estado",
  history_range_label: "Periodo",
  history_range_placeholder: "Cualquier fecha",

  // Table
  table_col_date: "Fecha",
  table_col_operation: "Compra",
  table_col_destination: "Destino",
  table_col_status: "Estado",
  table_empty_title: "Aún no hay compras",
  table_empty_description: "Cuando compres USDT, aparecerá aquí.",
  table_no_results_title: "Ninguna compra coincide",
  table_no_results_description: "Prueba con otro estado o periodo.",

  // Drawer
  drawer_title: "Compra de USDT",
  drawer_created_updated: "Creada {{created}} · Actualizada {{updated}}",
  drawer_open_order_page: "Abrir compra",
  drawer_not_found: "No encontramos esa compra. Puede ser de otra organización o el enlace está incompleto.",
  drawer_not_found_dismiss: "Cerrar aviso",

  // Summary
  summary_title: "Detalle",
  summary_debited: "Debitado",
  summary_received: "Entregado",
  summary_price: "Precio",
  summary_fees: "Comisiones",
  summary_network: "Red",
  summary_address: "Dirección",
  summary_tx_hash: "Hash de transacción",
  summary_tx_pending: "Disponible cuando se envíe",
  eta_label: "Tiempo estimado",
  eta_short: "≈ {{minutes}} min",
  eta_estimate: "Tiempo estimado: ≈ {{minutes}} min",
  eta_running: "En curso",
  eta_remaining: "quedan ~{{time}}",
  eta_elapsed: "{{time}} transcurrido",
  eta_progress_label: "Avance frente al tiempo estimado",
  eta_late: "Está tardando un poco más de lo estimado. Sigue en curso; no tienes que hacer nada.",
  eta_trend_slower: "Hoy las operaciones están tardando más de lo habitual.",
  eta_trend_slower_short: "Más lento de lo habitual",
  summary_view_explorer: "Ver en {{explorer}}",
  summary_concept: "Concepto",
  summary_created: "Creada",
  summary_paid_at: "Entregada",
  summary_failed_at: "Fallida",
  summary_order_id: "ID de la compra",

  // Order page
  order_breadcrumb: "Compra de USDT",
  order_not_found_title: "No encontramos esta compra",
  order_not_found_description: "Puede ser de otra organización o el enlace está incompleto.",
  order_back_to_history: "Ir al historial",
  order_headline_live: "Enviando {{amount}}",
  order_headline_paid: "Entregamos {{amount}}",
  order_headline_failed: "No pudimos entregar {{amount}}",
  order_subtitle: "A {{address}} en {{network}}.",
  order_live_title: "Actualizando en vivo",
  order_live_updated: "Última actualización {{time}}",
  order_live_stale: "No pudimos actualizar el estado. Lo que ves puede estar desactualizado.",
  order_view_history: "Ver historial",
  outcome_live_title: "En camino",
  outcome_live_message:
    "Estamos enviando tu {{currency}} por {{network}}. Esta página se actualiza sola; el hash aparece cuando la transacción sale.",
  outcome_paid_title: "Entregado",
  outcome_failed_title: "No se pudo entregar",
  outcome_failed_message:
    "El envío no se completó. Devolvimos a tu saldo en Coloca todo lo que se debitó, comisiones incluidas.",
  outcome_failed_returned: "Devuelto a tu saldo en Coloca",
  outcome_to_address: "A la dirección en {{network}}",

  // Timeline
  timeline_title: "Seguimiento",
  timeline_created: "Compra creada",
  timeline_processing: "Enviando",
  timeline_processing_hint: "La transacción está en curso.",
  timeline_delivered: "Entregado",
  timeline_failed: "Fallido y reembolsado",
  timeline_state_done: "completado",
  timeline_state_current: "en curso",
  timeline_state_todo: "pendiente",
  timeline_state_failed: "fallido",

  // CSV
  csv_filename: "compras-usdt",
  csv_col_id: "ID",
  csv_col_created_at: "Fecha de creación",
  csv_col_status: "Estado",
  csv_col_send_amount: "Monto debitado",
  csv_col_send_currency: "Moneda debitada",
  csv_col_receive_amount: "Monto entregado",
  csv_col_receive_currency: "Moneda entregada",
  csv_col_price: "Precio",
  csv_col_fee_conversion: "Comisión de conversión",
  csv_col_fee_delivery: "Comisión de envío",
  csv_col_network: "Red",
  csv_col_address: "Dirección de destino",
  csv_col_tx_hash: "Hash de transacción",
  csv_col_concept: "Concepto",
  csv_col_paid_at: "Fecha de entrega",
  csv_col_failed_at: "Fecha de fallo",

  // Copy
  copy_done: "{{field}} copiado",
  copy_failed: "No pudimos copiar. Selecciona el texto y cópialo a mano.",
  copy_address: "Dirección",
  copy_tx_hash: "Hash de transacción",
  copy_order_id: "ID de la compra",

  // Sell — page chrome
  sell_page_title: "Vender USDT",
  sell_page_description: "Envía USDT desde tu wallet y recibe pesos en tu billetera COP.",
  sell_page_new: "Nueva venta",
  sell_org_picker_required_hint: "Elige la organización que vende.",
  sell_org_picker_org_hint: "Los pesos se acreditan en la billetera COP de esta organización.",

  // Sell — availability
  sell_pairs_load_failed: "No pudimos cargar la venta de USDT",
  sell_pairs_empty:
    "La venta de USDT no está habilitada para tu cuenta. Habla con tu gerente de cuenta para activarla.",
  sell_unavailable_title: "Venta no disponible en este momento",
  sell_unavailable_not_configured: "La venta de {{asset}} aún no está habilitada para tu organización.",
  sell_unavailable_disabled: "La venta de {{asset}} está pausada temporalmente. Inténtalo más tarde.",
  sell_unavailable_generic: "La venta de {{asset}} no está disponible ahora mismo.",
  sell_unavailable_breb_key:
    "Para vender {{asset}} tu organización necesita una llave Bre-B activa: los pesos de la venta llegan a ella.",

  // Sell — amounts
  sell_amount_title: "¿Cuánto quieres vender?",
  sell_amount_send_label: "Vendes",
  sell_amount_receive_label: "Recibes en tu llave Bre-B",
  sell_send_limits_hint: "Mín. {{min}} {{currency}} · Máx. {{max}} {{currency}} por venta",
  sell_send_min_hint: "Mín. {{min}} {{currency}} por venta",
  sell_send_max_hint: "Máx. {{max}} {{currency}} por venta",
  sell_amount_below_min: "La venta mínima es de {{amount}} {{currency}}.",
  sell_amount_above_max: "La venta máxima es de {{amount}} {{currency}}.",
  sell_amount_out_of_range:
    "Este monto está fuera de los límites por venta ({{min}} – {{max}} {{currency}}).",

  // Sell — network
  buy_network_title: "¿En qué red quieres recibir?",
  buy_network_hint:
    "Elige la red de la wallet que recibe: si la wallet no está en esa red, los USDT no llegan.",
  access_check_failed: "No pudimos comprobar si Cripto está activo para tu organización.",
  access_check_retry: "Reintentar",
  saved_wallet_default_alias: "Billetera {{start}}…{{end}}",
  sell_network_title: "¿Por qué red envías?",
  sell_network_hint: "Elige la misma red que usa tu wallet: por otra red el envío no llega.",
  sell_network_option: "{{standard}} · comisión de red en {{gas}}",

  // Sell — wallet the deposit comes from
  sell_refund_title: "¿A qué wallet devolvemos los USDT?",
  sell_refund_hint: "Si la venta no se completa, devolvemos los {{asset}} a esta wallet.",
  sell_refund_saved_label: "Tu wallet",
  sell_refund_address_label: "Dirección de tu wallet",
  sell_refund_address_empty_hint:
    "Pega la dirección de tu wallet en esta red. Si envías desde un exchange, puede ser tu dirección de depósito en ese exchange.",
  sell_refund_warning:
    "¿Envías desde un exchange? Suma su comisión de retiro: tiene que llegar exactamente el monto de la venta, o la venta puede no completarse.",
  sell_refund_save_label: "Guardar esta wallet para próximas ventas",
  sell_saved_wallet_two_factor_description:
    "Ingresa el código de tu app de autenticación para guardar la wallet y continuar con la venta.",

  // Sell — key the pesos are paid to
  sell_payout_title: "Los pesos llegan a tu llave Bre-B principal",
  sell_payout_note: "Y se acreditan en tu billetera COP de Coloca.",

  // Sell — summary ticket
  sell_ticket_net: "Llega a tu billetera COP",
  sell_ticket_send: "Envías",
  sell_ticket_proceeds: "Pago a tu llave Bre-B",
  sell_ticket_fee: "Comisión",
  sell_ticket_fee_none: "Sin comisión",
  sell_submit: "Revisar venta",
  sell_submit_footnote:
    "Nada se mueve hasta que envíes los USDT. Si la venta no se completa, te los devolvemos a tu wallet.",

  // Sell — review blocks
  sell_block_readonly: "Tu rol puede ver esta sección, pero no vender.",
  sell_block_unavailable: "La venta no está disponible ahora mismo.",
  sell_block_empty: "Escribe cuánto quieres vender o recibir.",
  sell_block_refund: "Escribe la dirección de la wallet a la que devolvemos los USDT.",

  // Sell — confirm dialog
  sell_confirm_title: "Confirma tu venta",
  sell_confirm_headline: "Vas a vender {{send}} y recibir {{receive}}",
  sell_confirm_rules_title: "Cómo enviar los USDT",
  sell_rule_network_title: "Solo {{asset}} por {{network}}",
  sell_rule_network: "Token {{standard}}; la comisión de red se paga en {{gas}}. Contrato:",
  sell_rule_exact_title: "Exactamente {{amount}}",
  sell_rule_exact: "En una sola transferencia. Un monto distinto puede hacer que la venta no se complete.",
  sell_rule_wallet_title: "¿Desde un exchange? Suma su comisión",
  sell_rule_wallet:
    "El exchange descuenta su comisión de retiro del monto: retira lo necesario para que lleguen exactamente {{amount}}.",
  sell_confirm_refund_title: "Wallet de devolución",
  sell_confirm_network_warning:
    "Envía solo {{asset}} por {{network}}. Si envías otra moneda o usas otra red (Ethereum, Tron, Solana…), los fondos pueden perderse.",
  sell_confirm_acknowledge:
    "Haré que lleguen exactamente {{amount}} por {{network}}, en una sola transferencia.",
  sell_confirm_create: "Crear venta",
  sell_confirm_will_save_wallet: "Se guardará como “{{alias}}” para próximas ventas.",
  sell_creating_title: "Creando tu venta…",

  // Sell — errors
  sell_error_unconfirmed:
    "No pudimos confirmar si la venta se creó. Revisa tus ventas: si aparece, envía a la dirección que muestra; si no, cotiza de nuevo.",
  sell_error_not_created:
    "No pudimos crear la venta y no se movió nada. Te mostramos un precio nuevo para intentarlo otra vez.",
  sell_error_conflict:
    "Esta cotización ya se usó, o ya tienes una venta esperando depósito. Revisa tus ventas.",
  sell_error_verification_required: "Tu organización debe completar su verificación antes de vender.",
  sell_error_breb_key_required:
    "Para vender cripto tu organización necesita una llave Bre-B activa: los pesos llegan a ella.",
  sell_error_history: "Ver mis ventas",

  // Sell — statuses
  sell_status_awaiting_deposit: "Esperando depósito",
  sell_status_processing: "Procesando",
  sell_status_cop_sent: "Pesos enviados",
  sell_status_completed: "Acreditada",
  sell_status_expired: "Vencida",
  sell_status_refunding: "Devolviendo",
  sell_status_refunded: "Devuelta",

  // Sell — sale page
  sell_order_breadcrumb: "Venta de USDT",
  sell_order_not_found_title: "No encontramos esta venta",
  sell_headline_awaiting: "Envía {{amount}}",
  sell_headline_processing: "Recibimos tus {{asset}}",
  sell_headline_cop_sent: "Tus pesos van en camino",
  sell_headline_completed: "Acreditamos {{amount}}",
  sell_headline_expired: "La venta venció",
  sell_headline_refunding: "Estamos devolviendo tus {{asset}}",
  sell_headline_refunded: "Devolvimos tus {{asset}}",
  sell_subtitle: "Los pesos llegan a tu llave {{key}} y se acreditan en tu billetera COP.",

  // Sell — deposit slip
  sell_deposit_title: "Envía tus USDT a esta dirección",
  sell_deposit_qr_alt: "Código QR de la dirección de depósito en {{network}}",
  sell_deposit_amount: "Monto exacto",
  sell_deposit_address: "Dirección de depósito",
  sell_deposit_network: "Red",
  sell_deposit_contract: "Contrato {{asset}}:",
  sell_deposit_copy_amount: "Copiar monto",
  sell_deposit_copy_address: "Copiar dirección",
  sell_view_on_explorer: "Ver en {{explorer}}",
  sell_deposit_steps_title: "Cómo enviarlos desde MetaMask",
  sell_deposit_step_network: "Cambia MetaMask a la red {{network}}.",
  sell_deposit_step_send: "Elige {{asset}}, toca Enviar y pega la dirección de depósito.",
  sell_deposit_step_amount:
    "Escribe exactamente {{amount}} y confirma. Necesitas {{gas}} para la comisión de red.",
  sell_deposit_step_wait: "Vuelve aquí: esta página se actualiza sola cuando llegue tu depósito.",
  sell_deposit_warning:
    "Solo {{asset}} por {{network}}, en una sola transferencia y desde tu wallet. Otra moneda, otra red, un monto distinto o un envío tardío o dividido no se asocian a tu venta y no se devuelven automáticamente: recuperarlos es un trámite manual con soporte.",
  sell_deposit_window:
    "Tienes 15 minutos. Esta dirección es solo para esta venta: no la guardes ni la reutilices, porque luego se asigna a otras operaciones y un depósito tardío o repetido no se asocia a tu venta.",
  sell_deposit_time_left: "Vence en {{time}}",
  sell_deposit_expired_title: "Se acabó el tiempo para depositar",
  sell_deposit_expired_text:
    "No envíes nada a esta dirección: ya no está asociada a tu venta. Si ya enviaste, espera aquí: la página se actualiza sola.",
  sell_deposit_unavailable_title: "Dirección de depósito no disponible",
  sell_deposit_unavailable_text:
    "No envíes nada todavía: ahora no podemos mostrar una dirección válida para esta venta. La página se actualiza sola.",
  sell_deposit_tx_link: "Ver depósito en {{explorer}}",
  copy_deposit_amount: "Monto",
  copy_deposit_address: "Dirección de depósito",
  copy_sale_id: "ID de la venta",

  // Sell — outcome
  sell_outcome_processing_title: "Depósito recibido",
  sell_outcome_processing_message:
    "Recibimos tus {{asset}}. Estamos pagando los pesos a tu llave Bre-B; esta página se actualiza sola.",
  sell_outcome_cop_sent_title: "Pesos enviados",
  sell_outcome_cop_sent_message:
    "Pagamos {{amount}} a tu llave {{key}}. Los acreditamos en tu billetera COP en unos minutos.",
  sell_outcome_completed_title: "Acreditado",
  sell_outcome_completed_message: "Acreditamos {{amount}} en tu billetera COP.",
  sell_outcome_wallet_link: "Ir a billeteras",
  sell_outcome_expired_title: "La venta venció",
  sell_outcome_expired_message:
    "No recibimos tu depósito a tiempo. No envíes {{asset}} a esa dirección. Si ya los enviaste, seguimos revisándola: si llegan, la venta continúa o te los devolvemos a tu wallet.",
  sell_outcome_refunding_title: "Devolución en curso",
  sell_outcome_refunding_to: "Estamos devolviendo tus {{asset}} a",
  sell_outcome_refunded_title: "Devolvimos tus {{asset}}",
  sell_outcome_refunded_to: "Devolvimos tus {{asset}} a",

  // Sell — why a sale did not complete
  sell_reason_payment_timeout: "No recibimos el depósito a tiempo.",
  sell_reason_compliance: "El depósito no pasó la revisión de cumplimiento.",
  sell_reason_limit: "El monto supera los límites de la operación.",
  sell_reason_payout_failed: "No pudimos pagar los pesos a tu llave Bre-B.",
  sell_reason_refund_pending: "Estamos gestionando la devolución a tu wallet.",
  sell_reason_generic: "La venta no se pudo completar.",

  // Sell — timeline
  sell_timeline_created: "Venta creada",
  sell_timeline_awaiting: "Esperando tu depósito",
  sell_timeline_received: "Depósito recibido",
  sell_timeline_paying: "Pagando los pesos a tu llave",
  sell_timeline_cop_sent: "Pesos pagados a tu llave",
  sell_timeline_crediting: "Acreditando en tu billetera COP",
  sell_timeline_credited: "Acreditado en tu billetera COP",
  sell_timeline_expired: "Venció sin depósito",
  sell_timeline_refunding: "Devolviendo a tu wallet",
  sell_timeline_refunded: "Devuelto a tu wallet",

  // Sell — summary
  sell_summary_deposit: "Depósito",
  sell_summary_proceeds: "Pagado a tu llave Bre-B",
  sell_summary_fee: "Comisión",
  sell_summary_credited: "Acreditado",
  sell_summary_pending: "Pendiente",
  sell_summary_deposit_tx: "Hash del depósito",
  sell_summary_deposit_pending: "Disponible cuando llegue",
  sell_summary_payout_key: "Llave Bre-B",
  sell_summary_refund_wallet: "Wallet de devolución",
  sell_summary_completed_at: "Acreditada",
  sell_summary_expired_at: "Vencida",
  sell_summary_refunded_at: "Devuelta",
  sell_summary_refund_tx: "Transacción de devolución",
  sell_refund_tx_link: "Ver devolución en {{explorer}}",
  sell_summary_sale_id: "ID de la venta",

  // History — purchases and sales
  history_hub_title: "Historial",
  history_hub_description: "Tus compras y ventas de USDT, con su estado y el hash de cada transacción.",
  history_tab_buys: "Compras",
  history_tab_sells: "Ventas",
  sell_history_count_one: "{{count}} venta",
  sell_history_count_other: "{{count}} ventas",
  sell_history_export_empty: "No hay ventas para exportar con estos filtros.",
  sell_history_load_error: "No pudimos cargar tus ventas.",
  sell_table_col_operation: "Venta",
  sell_table_empty_title: "Aún no hay ventas",
  sell_table_empty_description: "Cuando vendas USDT, aparecerá aquí.",
  sell_table_no_results_title: "Ninguna venta coincide",
  sell_drawer_title: "Venta de USDT",
  sell_drawer_open: "Abrir venta",
  sell_drawer_not_found:
    "No encontramos esa venta. Puede ser de otra organización o el enlace está incompleto.",

  // Sell — CSV
  sell_csv_filename: "ventas-usdt",
  sell_csv_col_deposit_amount: "Monto depositado",
  sell_csv_col_deposit_currency: "Moneda depositada",
  sell_csv_col_deposit_tx: "Hash del depósito",
  sell_csv_col_proceeds: "Pagado a la llave",
  sell_csv_col_fee: "Comisión",
  sell_csv_col_credited: "Acreditado",
  sell_csv_col_currency: "Moneda acreditada",
  sell_csv_col_payout_key: "Llave Bre-B",
  sell_csv_col_refund_wallet: "Wallet de devolución",
  sell_csv_col_completed_at: "Fecha de acreditación",
  sell_csv_col_refunded_at: "Fecha de devolución",
  // Volume discount
  volume_title: "Entre más compras, más barato el dólar",
  volume_meter_label: "Descuento por volumen",
  volume_meter_saving: "Pagas {{amount}} menos por dólar que en la compra mínima.",
  volume_meter_minimum: "El precio por dólar baja a medida que compras más.",
  volume_meter_best: "Ya tienes prácticamente el mejor precio.",
  volume_suggestion_amount: "Compra {{amount}}",
  volume_suggestion_wallet: "Compra todo tu saldo · {{amount}}",
  volume_suggestion_max: "Compra el máximo · {{amount}}",
  volume_suggestion_price: "{{price}} por dólar · {{savings}} menos",
  volume_suggestion_price_only: "{{price}} por dólar",
  volume_suggestion_extra: "+{{amount}} extra",
  volume_top_up: "Con {{amount}} pagarías {{price}} por dólar.",
  volume_top_up_action: "Recargar billetera",
  volume_insufficient_title: "No tienes saldo suficiente",
  volume_insufficient_text:
    "Con {{amount}} recibirías un descuento de {{savings}} por dólar sobre la compra mínima.",
  volume_insufficient_wallet: "Compra con todo tu saldo · {{amount}}",
  volume_sell_title: "Entre más vendes, más pesos por dólar",
  volume_sell_meter_saving: "Recibes {{amount}} más por dólar que en la venta mínima.",
  volume_sell_meter_minimum: "Recibes más pesos por dólar a medida que vendes más.",
  volume_sell_suggestion_amount: "Vende {{amount}}",
  volume_sell_suggestion_price: "{{price}} por dólar · {{savings}} más",
};
